import axios from "axios";

export const state = {
    reportexpensescategory: [],
};

export const getters = {
    reportexpensescategory: state => state.reportexpensescategory,
};

export const mutations = {
    setReportExpenseCategory(reportexpensescategory, newValue) { state.reportexpensescategory = newValue},
};

export const actions = {
    fetchReportExpenseCategory({ commit }) {
        axios.get('/reportexpensescategory').then(res => {
            commit('setReportExpenseCategory', res.data.expensesales)
        })
    },
    filterReportExpenseCategory({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportexpensescategory";
        axios.post(url, formData).then((response) => {
            commit('setReportExpenseCategory', response.data.expensesales)
        })
    },
};
